module.exports = __webpack_public_path__ + "static/on-tyranny-bb50743d48105de04d577b2216b74b39.jpg";